import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChecklist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChecklist"><Path fillRule="evenodd" clipRule="evenodd" d="M9.79907 5.09352L5.59203 10.773L2.70874 8.8268L3.54795 7.58353L5.24126 8.72652L8.59373 4.20068L9.79907 5.09352ZM11 6.99977H21V8.49977H11V6.99977ZM9.79907 14.0935L5.59203 19.773L2.70874 17.8268L3.54795 16.5835L5.24126 17.7265L8.59373 13.2007L9.79907 14.0935ZM11 15.4998H21V16.9998H11V15.4998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChecklist;
